import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { deleteAssortmentGroup } from '../api/deleteAssortmentGroup'
import { REQUEST_DELETE_ASSORTMENT_GROUP } from '../constants'

export const requestRemoveAssortmentGroup = createAsyncThunk(
  REQUEST_DELETE_ASSORTMENT_GROUP,
  async (entryId: number) => {
    const isDeleted = await deleteAssortmentGroup(entryId)
    return isDeleted ? entryId : null
  }
)
